import type { TranslationMessages } from '../../types';

export const leave: TranslationMessages = {
  title: 'Yêu cầu nghỉ phép',
  subtitle: 'Quản lý và yêu cầu ngày nghỉ',
  request_button: 'Yêu cầu nghỉ phép',
  new_request_title: 'Gửi yêu cầu nghỉ phép',
  new_request_desc: 'Điền chi tiết yêu cầu nghỉ phép của bạn.',
  type_label: 'Loại',
  type_unpaid: 'Không lương',
  type_paid: 'Có lương',
  type_sick: 'Nghỉ ốm',
  type_other: 'Khác',
  reason_placeholder: 'Tại sao bạn cần nghỉ phép?',
  no_requests: 'Không tìm thấy yêu cầu nghỉ phép nào',
  type: 'Loại',
  status_approved: 'Đã duyệt',
  status_rejected: 'Đã từ chối',
  status_cancelled: 'Đã hủy',
  status_pending: 'Đang chờ',
  fetch_failed: 'Không thể tải yêu cầu nghỉ phép',
  create_success: 'Yêu cầu nghỉ phép đã được gửi thành công',
  create_failed: 'Không thể gửi yêu cầu nghỉ phép',
  approved_success: 'Yêu cầu nghỉ phép đã được duyệt thành công',
  approved_failed: 'Không thể duyệt yêu cầu nghỉ phép',
  rejected_success: 'Yêu cầu nghỉ phép đã bị từ chối thành công',
  rejected_failed: 'Không thể từ chối yêu cầu nghỉ phép',
  delete_success: 'Yêu cầu nghỉ phép đã được xóa thành công',
  delete_failed: 'Không thể xóa yêu cầu nghỉ phép',
  invalid_dates: 'Ngày kết thúc không thể trước ngày bắt đầu',
  rejection_reason_prompt: 'Nhập lý do từ chối:',
};
